import React, { useState, useEffect } from "react";

const ContactSection = () => {
  const [displayedText, setDisplayedText] = useState("");
  const text = "Visit Us or Get in Touch\nTwin Star Industries.";

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, index + 1));
      index++;
      if (index === text.length) clearInterval(interval);
    }, 50); // speed in ms
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-gray-50 px-4 sm:px-6 md:px-12 lg:px-20 py-12 sm:py-16 lg:py-20">
      {/* Contact Label */}
      <div className="flex items-center gap-2 mb-4">
        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
        <span className="text-base sm:text-lg font-medium">Contact</span>
      </div>

      {/* Animated Heading */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-black leading-snug sm:leading-tight mb-8 sm:mb-10 whitespace-pre-line">
        {displayedText}
      </h1>

      {/* Embedded Google Map */}
      <div className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[500px] rounded-lg overflow-hidden shadow-lg">
        <iframe
          title="Twin Star Industries Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5094.852035186591!2d80.24569130188264!3d12.969780072227499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d71b31b23bf%3A0xb036dd6f6e5f155c!2sTwin%20Star%20Industries!5e0!3m2!1sen!2sin!4v1755194160054!5m2!1sen!2sin"
          width="100%"
          height="100%"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactSection;
